module.exports = {
  BUILD_CONTAINER: 'BUILD_CONTAINER',
  START_CONTAINER: 'START_CONTAINER',
  SENDTOBOT: 'SENDTOBOT',
  STOP_CONTAINER: 'STOP_CONTAINER',
  CLEAN_CONTAINER: 'CLEAN_CONTAINER'
}
